import { render, staticRenderFns } from "./static-report-edit.vue?vue&type=template&id=53bcd24a&scoped=true"
import script from "./static-report-edit.vue?vue&type=script&lang=ts"
export * from "./static-report-edit.vue?vue&type=script&lang=ts"
import style0 from "./static-report-edit.vue?vue&type=style&index=0&id=53bcd24a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bcd24a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53bcd24a')) {
      api.createRecord('53bcd24a', component.options)
    } else {
      api.reload('53bcd24a', component.options)
    }
    module.hot.accept("./static-report-edit.vue?vue&type=template&id=53bcd24a&scoped=true", function () {
      api.rerender('53bcd24a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/final-report/static-report-edit/static-report-edit.vue"
export default component.exports